module.exports = __webpack_public_path__ + "img/UNDEFINED.c9c186ef.png";